/* eslint-disable react/display-name */
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isOpenSelector,
  setIsOpenAction,
} from '../../../services/forms/features';
import { PartialBy } from '../../../utils/types';

interface WithFormJSIsOpenProps {
  isOpen: boolean;
  onChange: (isOpen?: any) => void;
}

export const withFormJSIsOpen =
  <P extends EntityId & WithFormJSIsOpenProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'isOpen' | 'onChange'>) => {
    const isOpen = useSelector(isOpenSelector(props.id));
    const dispatch = useDispatch();
    const setIsOpen = setIsOpenAction(dispatch);
    const onChange = useCallback(
      newIsOpen => setIsOpen({ inputId: props.id, isOpen: newIsOpen }),
      [props.id, setIsOpen]
    );
    return <Component {...(props as P)} isOpen={isOpen} onChange={onChange} />;
  };
